import React from 'react';  

// ExternalLinkButton component definition 
const ExternalLinkButton = ({ url, label }) => (
  <a href={url} target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'none' }}>
    <button style={{ padding: '10px 20px', margin: '10px', backgroundColor: 'blue', color: 'white', border: 'none', borderRadius: '5px', cursor: 'pointer' }}>
      {label}
    </button>
  </a>
);

// SponsorRegistration component definition 
const SponsorRegistration = () => {   
  return (     
    <div className="container mx-auto px-4">       
      <h1 className="text-4xl font-extrabold text-blue-900 mt-12 mb-8">Sponsorship Program</h1>       
      <p className="text-lg text-gray-700 mb-4">
  This Conference will provide a timely technology forum for professional engineers, researchers, specialist contractors, regulators, educators, engineering students and their academic supervisors. Our esteemed speakers and attendees will share their collective knowledge and experiences, encompassing both fundamental and applied aspects, and work together towards advancing the state of composites materials manufacturing for sustainable mining equipment. <br /><br />
  Sponsorship request needs to be submitted electronically via Centre website, URL is located at bottom of page 1 of this document); once sponsorship request is received, we will provide you with an invoice for sponsorship contribution. <br /><br />
  <strong>Categories:</strong> Platinum, AU$10,000; Gold, AU$7,000; Silver, AU$5,000; (All GST inclusive) <br /><br />
  <strong>Benefits:</strong><br />
   Free registrations (3 for Platinum, 2 for Gold and 1 for Silver) <br />
   Complimentary Exhibition Space, package includes: <br />
  &nbsp;&nbsp;&nbsp;&nbsp;Dimensions of 2m x 1m booth area at the Conference <br />
  &nbsp;&nbsp;&nbsp;&nbsp;Booth positions (priority position for Platinum, first come first serve for Gold and Silver) <br />
   Verbal recognition at official launch and closing sessions <br />
   Corporate banner displayed in the plenary room throughout sessions <br />
   Opportunity to utilise the Conference for marketing purposes including: <br />
  &nbsp;&nbsp;&nbsp;&nbsp;Website (logo and hyper-link to organisation’s site) <br />
  &nbsp;&nbsp;&nbsp;&nbsp;Logo appearing on Conference announcements <br />
  &nbsp;&nbsp;&nbsp;&nbsp;All Conference promotional material recognising your organisation: 1 page advertisement in the Conference Study Package <br />
   One satchel insert (product and/or information) included in all delegate satchels <br /><br />
  <strong>Secured sponsor(s) include:</strong> Office of Chief Scientist and Engineers, New South Wales, Australia.
</p>       
      {/* Example usage of ExternalLinkButton */}
      <ExternalLinkButton          
        url="https://pay.uow.edu.au/InternationalConferenceonsponsership"          
        label="Sponsor Registration"       
      />     
    </div>   
  ); 
};  

export default SponsorRegistration;